export default __webpack_public_path__ + "static/media/profile2.e6190802.jpg";